module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/all-caregories/all-caregories.component.css
// module id = ./src/app/pages/all-caregories/all-caregories.component.css
// module chunks = main